/**
 * @fileoverview Form navigation buttons and step 3 error display for Register.
 * @module pages/register/RegisterFormActions
 */
import styles from "../../styles/Register.module.css";

const RegisterFormActions = ({
  t,
  stepNumber,
  error,
  isStep1Valid,
  isStep2Valid,
  isStep3Valid,
  handleNextFromStep1,
  handleNextFromStep2,
  handlePreviousFromStep2,
  handlePreviousFromStep3,
  handleCreateAccount,
}) => (
  <>
    {stepNumber === 3 && error && (
      <div className={styles.errorContainer}>
        <span className={styles.errorMessage}>
          {t(`errors.register.${error}`)}
        </span>
      </div>
    )}

    {stepNumber === 1 && (
      <div className={styles.formActions}>
        <div>
          <button
            className={styles.nextSingleButton}
            type="button"
            disabled={!isStep1Valid}
            onClick={handleNextFromStep1}
          >
            {t("pages.register.nextButtonLabel")}
          </button>
        </div>
      </div>
    )}

    {stepNumber === 2 && (
      <div className={styles.formActionsStep2}>
        <div>
          <button
            className={styles.previousButton}
            type="button"
            disabled={false}
            onClick={handlePreviousFromStep2}
          >
            {t("pages.register.previousButtonLabel")}
          </button>
          <button
            className={styles.nextNotSingleButton}
            type="button"
            disabled={!isStep2Valid}
            onClick={handleNextFromStep2}
          >
            {t("pages.register.nextButtonLabel")}
          </button>
        </div>
      </div>
    )}

    {stepNumber === 3 && (
      <div className={styles.formActionsStep3}>
        <div>
          <button
            className={styles.previousButton}
            type="button"
            disabled={false}
            onClick={handlePreviousFromStep3}
          >
            {t("pages.register.previousButtonLabel")}
          </button>
          <button
            className={styles.createAccountButton}
            type="button"
            disabled={!isStep3Valid}
            onClick={handleCreateAccount}
          >
            {t("pages.register.createAccountButtonLabel")}
          </button>
        </div>
      </div>
    )}
  </>
);

export default RegisterFormActions;
